export default __webpack_public_path__ + "static/media/TRUCK9.a7ded9b6.jpg";